'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatPhoneNumber;

var _getCleanPhoneNumber = require('./get-clean-phone-number');

var _getCleanPhoneNumber2 = _interopRequireDefault(_getCleanPhoneNumber);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function formatPhoneNumber(value) {
  var phoneNumber = (0, _getCleanPhoneNumber2.default)('' + value);

  if (!phoneNumber) {
    return '';
  }

  if (phoneNumber.length <= 3) {
    return phoneNumber;
  }

  if (phoneNumber.length <= 6) {
    return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3);
  }

  return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
}